import { render, staticRenderFns } from "./ExcellentCases.vue?vue&type=template&id=638fc711&scoped=true"
import script from "./ExcellentCases.vue?vue&type=script&lang=js"
export * from "./ExcellentCases.vue?vue&type=script&lang=js"
import style0 from "./ExcellentCases.vue?vue&type=style&index=0&id=638fc711&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638fc711",
  null
  
)

export default component.exports